// Field-name shims that translate the new API's camelCase responses back to
// the snake_case shapes the existing components were built against. This keeps
// the migration mechanical — no need to chase down every grandchild render.
//
// Long-term: components can be updated to consume camelCase directly and these
// helpers can be deleted. Today they keep the diff narrow.

export function normalizeGameToSnake(g: any): any {
  if (!g) return g;
  return {
    ...g,
    home_team: g.homeTeam,
    away_team: g.awayTeam,
    home_flag: g.homeFlag,
    away_flag: g.awayFlag,
    home_score: g.homeScore,
    away_score: g.awayScore,
    live_home_score: g.liveHomeScore,
    live_away_score: g.liveAwayScore,
    is_finished: g.isFinished,
    is_live: g.isLive,
    kickoff_time: g.kickoffTime,
    group_label: g.groupLabel,
    home_team_placeholder: g.homeTeamPlaceholder,
    away_team_placeholder: g.awayTeamPlaceholder,
    status_short: g.statusShort,
    last_live_sync: g.lastLiveSync,
    game_no: g.gameNo,
    external_id: g.externalId,
  };
}

export function normalizeTipToSnake(t: any): any {
  if (!t) return t;
  return {
    ...t,
    user_id: t.userId,
    game_id: t.gameId,
    home_tip: t.homeTip,
    away_tip: t.awayTip,
    points_earned: t.pointsEarned,
    xp_earned: t.xpEarned,
    created_at: t.createdAt,
    updated_at: t.updatedAt,
  };
}
